// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import AliyunOutlinedSvg from "@ant-design/icons-svg/es/asn/AliyunOutlined";
import AntdIcon from '../components/AntdIcon';

var AliyunOutlined = function AliyunOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: AliyunOutlinedSvg
  }));
};

AliyunOutlined.displayName = 'AliyunOutlined';
export default React.forwardRef(AliyunOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/AliyunOutlined.js
// module id = 555
// module chunks = 0